import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d5lao1dk: FaireBrandEntity = {
  token: "b_d5lao1dk",
  type: "brand",
  name: "offensivedelightful",
  avatarUrl:
    "https://cdn.faire.com/fastly/8abc2282dad2252895b590921f9e92174954d6c7ed5a6581072e4d7567b0040e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d7188679fcc3ea85f91948bd36bbc87502d45e7f99e6c70fa94f1fab6391c81f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8abc2282dad2252895b590921f9e92174954d6c7ed5a6581072e4d7567b0040e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d7188679fcc3ea85f91948bd36bbc87502d45e7f99e6c70fa94f1fab6391c81f.png",
  location: "los angeles, CA, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 494,
  isTopShop: true,
  isInsider: true,
  description:
    'We hijack the visual language of wholesome Americana — pinups, cowgirls, kittens...— and we kinda detonate it. With profanity, politics, and swagger we believe in the funny. "Offensive" + "delightful" isn\'t a gimmick, it\'s a formula: the art delivers sweetness, the copy delivers punch. Sardonic-sweet, feminist, unambiguously progressive, and  never afraid of the political moment. So join us in the good fight to keep our senses about us, when all others are losing theirs. here here!',
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:04.365Z",
    importedBy: "entity-db-cli",
  },
};
